<db-dialog-wrapper
        [dialog]="this" [width]="width||'500px'"
        [height]="height" [hasCloseButton]="hasCloseButton">
    <div class="db-confirm-dialog db-confirm-dialog-{{size}}" [class.align-left]="alignLeft"
         [class.from-staging]="fromStaging">
        <div class="db-confirm-dialog__header" [innerHTML]="header"></div>
        @if (website && !makePrimary) {
            <div class="db-confirm-dialog__message" [formGroup]="confirmDialog">
                <p [innerHTML]="message"></p>
                @if (params && params?.pluginsCount) {
                    <span>{{ params.pluginsCount }}</span>
                }
                @if (params && params?.themesCount && params?.pluginsCount) {
                    <span> and </span>
                }
                @if (params && params?.themesCount) {
                    <span>{{ params.themesCount }}</span>
                }
                @if (params) {
                    <span>?</span>
                }
                @if (website) {
                    <input type="text" name="subdomain" formControlName="subdomain"
                           [style.border-color]="(confirmDialog.controls['subdomain'].invalid && ((confirmDialog.controls['subdomain'].touched && !confirmDialog.controls['subdomain'].errors['required']) || formSubmitted))  ? '#E95E5B' : null"
                           class="db-fc-input"
                           [placeholder]="'text_confirmSubdomain' | dbText: { siteUrl: confirmationSubdomain }"/>
                }
                <div class="db-server-error-wrap">
                    <div class="db-server-error-wrap">
                        @if (website && (confirmDialog.controls['subdomain'].invalid && ((confirmDialog.controls['subdomain'].touched
                            && !confirmDialog.controls['subdomain'].errors['required']) || formSubmitted))) {
                            <div>{{ 'text_domainNameWrongValidation' | dbText }}</div>
                        }
                    </div>
                </div>
            </div>
        }
        @if (!website || (website && makePrimary)) {
            <div class="db-confirm-dialog__message">
                <p [innerHTML]="message"></p>
                @if (params?.pluginsCount) {
                    <span>{{ params.pluginsCount }}</span>
                }
                @if (params?.themesCount && params?.pluginsCount) {
                    <span> and </span>
                }
                @if (params?.themesCount) {
                    <span>{{ params.themesCount }}</span>
                }
                @if (params) {
                    <span>?</span>
                }
            </div>
        }
        @if (screen === 'primary-domain' && !ssl  && !is10webDomain) {
            <div class="db-domain-primary">
                @if (enableSSL) {
                    <label class="db-fc-checkbox"><input type="checkbox" [formControl]="enableSSL"
                                                         [checked]="enableSSL.value"><span><i
                            class="db-icon db-icon-check"></i></span></label>
                }
                <span class="db-ssl-text">Enable Free SSL provided by {{ companyName }}</span>
            </div>
        }

        <div class="db-confirm-dialog__buttons" [class.db-right]="fromStaging || alignButtonsRight">
            @if (cancelButtonText) {
                <a class="{{cancelButtonClass}}" (click)="cancel()" [style.width]="buttonWidth ? buttonWidth : ''">
                    <span>{{ cancelButtonText | lowerCaseSpecificWords }}</span></a>
            }
            @if (website && !makePrimary) {
                <a class="{{confirmButtonClass}} ds-resizable  sl-confirm-button"
                   (click)="confirm()"
                   [ngClass]="{'db-button_disabled': confirmDialog.controls['subdomain'].value === '', 'ds-btn-l':
          confirmButtonText === 'Deactivate & Delete'}"><span>{{ confirmButtonText | lowerCaseSpecificWords }}</span></a>
            }
            @if (!disableMakePrimary && (!website || (website && makePrimary))) {
                <a class="{{confirmButtonClass}} ds-resizable sl-confirm-button"
                   [style.width]="buttonWidth ? buttonWidth : fromStaging && '82px'"
                   [ngClass]="{'ds-btn-l': confirmButtonText === 'Deactivate & Delete'}" (click)="confirm()">
                    <span>{{ confirmButtonText | lowerCaseSpecificWords }}</span></a>
            }

        </div>
    </div>
</db-dialog-wrapper>
